import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { PAYMENTS_CONFIG } from '../../payments.config';
import { SummaryData } from '../../models/payment.models';

@Component({
  selector: 'lib-payment-summary',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NzFormModule,
    NzInputNumberModule,
  ],
  templateUrl: './summary.html',
})
export class Summary implements OnInit {
  readonly cart = input.required<SummaryData>();
  readonly showCouponCode = input(true);
  readonly isManualInput = input(false);
  readonly priceChange = output<number>();

  private readonly config = inject(PAYMENTS_CONFIG);
  private readonly fb = inject(FormBuilder);

  priceFormGroup: FormGroup = this.fb.group({
    amount: [null, [Validators.required, Validators.min(1)]],
  });

  ngOnInit(): void {
    this.priceFormGroup.valueChanges.subscribe(() => {
      if (this.priceFormGroup.valid) {
        const amount = Number(this.priceFormGroup.value.amount);
        if (!isNaN(amount)) {
          this.cart().amount = amount;
          this.cart().total = amount;
          this.priceChange.emit(amount);
        }
      }
    });
  }

  get totalPrice(): number {
    return this.cart().total + this.cart().tax;
  }

  get currencyCode(): string {
    return this.cart().currency?.symbol || this.cart().currency?.name || 'USD';
  }

  get showSubPlans(): boolean {
    return this.config.appPortal === 'Repz';
  }
}
